import { createActions } from 'redux-actions';

export const { providerCriteriaRequest, providerCriteriaSuccesed, providerCriteriaFailed } = createActions(
  'PROVIDER_CRITERIA_REQUEST',
  'PROVIDER_CRITERIA_SUCCESED',
  'PROVIDER_CRITERIA_FAILED',
);
